import React from "react";
import menu from '../Assets/menu.png';

 export function Hamburger() {
    return (
        <img src={menu} alt="icon" className="on" />
    );
}